import { useTranslation } from 'react-i18next';
import { CompanyType } from '../../participantEnums';

export const useCompanyTypes = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: CompanyType.B2B,
      label: t('participants.enums.companyType.B2B'),
    },
    {
      value: CompanyType.B2C,
      label: t('participants.enums.companyType.B2C'),
    },
    {
      value: CompanyType.NGO,
      label: t('participants.enums.companyType.NGO'),
    },
    {
      value: CompanyType.Educational,
      label: t('participants.enums.companyType.EDUCATIONAL'),
    },
    {
      value: CompanyType.Independant,
      label: t('participants.enums.companyType.INDEPENDANT'),
    },
    {
      value: CompanyType.Public,
      label: t('participants.enums.companyType.PUBLIC'),
    },
    {
      value: CompanyType.Gouvernment,
      label: t('participants.enums.companyType.GOUVERNMENT'),
    },
  ];
};
